export const regexPatterns = {
  expirationDate: /^(0[1-9]|1[0-2])\/\d{2}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};
